var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{class:_vm.classes,attrs:{"name":_vm.name,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.input,"blur":_vm.blur,"focus":_vm.focus}})}
var staticRenderFns = []

export { render, staticRenderFns }